<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
const moment = require("moment");
import Vue from "vue";
import Swal from "sweetalert2";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
const axios = require("axios").default;
Vue.component("Dropzone", Dropzone);

import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  HomeIcon,
  UserIcon,
  UserCheckIcon,
  MailIcon,
  KeyIcon,
  SmartphoneIcon,
  AlertCircleIcon,
  CheckCircleIcon,
  PlusIcon,
  MinusIcon,
} from "vue-feather-icons";
/**
 * Auth-signup component
 */
export default {
  components: {
    Dropzone: Dropzone,
  },
  data() {
    return {
      configs: {
        timePicker: {
          wrap: true,
          enableTime: true,
          enableSeconds: false,
          noCalendar: true,
        },
      },
      dropzoneOptions: {
        url: "https://app.quarantinefacility.ph/api/upload",
        thumbnailWidth: 150,
      },
      isCondensed: false,
      loginForm: {
        name: [
          {
            customer_name: "",
          },
        ],
        email: "",
        contact_number: "",
        hotel_id: "",
        check_in_date: moment()
          .add(2, "days")
          .format(),
        check_out_date: moment()
          .add(16, "days")
          .format(),
        files: [],
        numRooms: 1,
        shuttle: false,
      },
      totalAmount: 0,
      hotels: {},
      response: "",
      isLoading: false,
      fullPage: true,
      errorMessage: "",
    };
  },
  components: {
    CheckCircleIcon,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    HomeIcon,
    UserIcon,
    UserCheckIcon,
    MailIcon,
    KeyIcon,
    SmartphoneIcon,
    AlertCircleIcon,
    flatPickr,
    PlusIcon,
    MinusIcon,
    Loading,
  },
  computed: {
    // a computed getter
    computePrice: function() {
      // `this` points to the vm instance
      if (this.hotels) {
        this.hotels.forEach((hotel) => {
          if (hotel.id === this.loginForm.hotel_id) {
            if (this.loginForm.shuttle === true)
              this.totalAmount = hotel.price * this.loginForm.numRooms + 3000;
            else this.totalAmount = hotel.price * this.loginForm.numRooms;
          }
        });
      }

      console.log(this.totalAmount);
      return this.totalAmount;
    },
  },
  created: function() {
    if (this.$route.params.hotels) this.hotels = this.$route.params.hotels;
    else {
      this.isLoading = true;
      this.getHotels();
    }
    this.loginForm.hotel_id = this.$route.params.key;
  },
  methods: {
    postBooking() {
      if (
        this.loginForm.check_in_date <
        moment()
          .add(1, "days")
          .format()
      ) {
        this.response = false;
        this.errorMessage =
          "Date cannot be day before " +
          moment()
            .add(1, "days")
            .format("LL");
        setTimeout(() => {
          self.isLoading = false;
          document.getElementById("modalButton").click();
        }, 1000);
      }
      this.isLoading = true;
      let self = this;
      let formData = new FormData();
      formData.append("hotel_id", this.loginForm.hotel_id);
      formData.append("numRooms", this.loginForm.numRooms);
      formData.append("booking_start", this.loginForm.check_in_date);
      formData.append("booking_end", this.loginForm.check_out_date);
      formData.append("customer_name", JSON.stringify(this.loginForm.name));
      formData.append("phone_number", this.loginForm.contact_number);
      formData.append("email", this.loginForm.email);
      formData.append("time", this.loginForm.time);
      formData.append("details", this.loginForm.details);
      formData.append("files", this.loginForm.files);
      formData.append("shuttle", this.loginForm.shuttle);
      formData.append("totalAmount", this.totalAmount);
      formData.append("company", this.loginForm.company);

      axios
        .post("https://app.quarantinefacility.ph/api/new_booking", formData)
        .then(function(response) {
          self.isLoading = false;
          console.log(response);
          Swal.fire({
            title: "Booking Successful",
            text: "Please wait for the confirmation of your booking.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
          }).then((result) => {
            console.log(result);

            if (result.isConfirmed) {
              window.location.href = "https://quarantinefacility.ph";
            }
          });
        })
        .catch(function(error) {
          console.log(error);
          self.response = false;
          this.errorMessage = "Something went wrong";
        });
    },
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
    handleFile() {
      this.loginForm.file = this.$refs.file.files;
    },
    getHotels() {
      let self = this;
      axios
        .get("https://app.quarantinefacility.ph/api/get_hotel")
        .then(function(response) {
          self.hotels = response.data;
          setTimeout(() => {
            self.isLoading = false;
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addPerson(value, fieldType) {
      fieldType.push({ customer_name: "" });
    },
    removePerson(index, fieldType) {
      if (fieldType.length > 1) fieldType.splice(index, 1);
      console.log(fieldType.length);
    },
    tnc() {
      const modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    closeModal() {
      const modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    uploadSuccess(file, response) {
      this.isLoading = false;
      console.log("File Successfully Uploaded with file name: " + response);
      this.loginForm.files.push(response);
    },
    uploadError(file, message) {
      console.log("An Error Occurred");
    },
    fileRemoved() {},
    sendingEvent(file, message) {
      this.isLoading = true;
    },
  },
};
</script>

<template>
  <div>
    <!-- Loader -->
    <header
      id="topnav"
      class="defaultscroll sticky"
      style="background-color: white;"
    >
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link to="/" class="logo"
            ><img src="images/quarantine_black.png" height="50" alt=""
          /></router-link>
        </div>
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul
            class="navigation-menu"
            v-scroll-spy-active="{ selector: 'li.has-submenu' }"
          >
            <li class="has-submenu">
              <a href="https://quarantinefacility.ph/">Home</a>
            </li>
            <li class="has-submenu">
              <a href="https://quarantinefacility.ph/hotels">Rooms</a>
            </li>
            <li class="has-submenu">
              <a href="https://quarantinefacility.ph" v-scroll-to="'#services'"
                >Services</a
              >
            </li>
            <li class="has-submenu">
              <a href="https://quarantinefacility.ph" v-scroll-to="'#contact'"
                >Contact</a
              >
            </li>
          </ul>
          <!--end navigation menu-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>

    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <!-- Hero Start -->
    <section class="bg-auth-home d-table w-100">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="card shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center">Book your Quarantine</h4>
                <form v-on:submit.prevent="postBooking" class="login-form mt-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label>Hotel <span class="text-danger">*</span></label>
                        <select
                          v-model="loginForm.hotel_id"
                          class="form-control custom-select"
                          placeholder="Choose your hotel"
                          required=""
                        >
                          <option
                            v-for="(hotel, index) in hotels"
                            :key="index"
                            :value="hotel.id"
                          >
                            {{ hotel.hotel_name }} - P{{ hotel.price }}/night
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label
                          >Number of Room/s
                          <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <smartphone-icon
                            class="fea icon-sm icons"
                          ></smartphone-icon>
                          <input
                            v-model="loginForm.numRooms"
                            type="number"
                            min="1"
                            class="form-control pl-5"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="(name, index) in this.loginForm.name"
                      :key="index"
                      class="col-md-12"
                    >
                      <div class="form-group">
                        <label
                          >Full Name<span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input
                            v-model="name.customer_name"
                            type="text"
                            class="form-control pl-5"
                            placeholder="Full Name"
                            name="s"
                            required=""
                          />
                        </div>
                      </div>
                      <span style="position:relative;top:-55px;left:85%;">
                        <minus-icon
                          v-on:click="removePerson(index, loginForm.name)"
                          style="color:red"
                        >
                          Remove
                        </minus-icon>
                        <plus-icon
                          v-on:click="addPerson(name, loginForm.name)"
                          style="color:green"
                        >
                          Add
                        </plus-icon>
                      </span>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label
                          >Your Email <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <mail-icon class="fea icon-sm icons"></mail-icon>
                          <input
                            v-model="loginForm.email"
                            type="email"
                            class="form-control pl-5"
                            placeholder="your@email.com"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label
                          >Contact Number
                          <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <smartphone-icon
                            class="fea icon-sm icons"
                          ></smartphone-icon>
                          <input
                            v-model="loginForm.contact_number"
                            type="number"
                            :maxlength="3"
                            min="1"
                            class="form-control pl-5"
                            placeholder="091234567890"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label>Company Name </label>
                        <div class="position-relative">
                          <input
                            v-model="loginForm.company"
                            type="text"
                            class="form-control pl-5"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label> Check in : </label>
                        <flat-pickr
                          v-model="loginForm.check_in_date"
                          class="flatpickr flatpickr-input form-control"
                          id="checkin-date"
                          name="date"
                          required=""
                        >
                        </flat-pickr>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label> Check out : </label>
                        <flat-pickr
                          v-model="loginForm.check_out_date"
                          class="flatpickr flatpickr-input form-control"
                          id="checkout-date"
                          name="date"
                          required=""
                        >
                        </flat-pickr>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label> Arrival Time: </label>
                        <flat-pickr
                          v-model="loginForm.time"
                          :config="configs.timePicker"
                          class="form-control"
                          placeholder="Time"
                        >
                        </flat-pickr>
                        <label> Total Amount: </label>
                        <p>{{ computePrice }}</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label> Additional Note/Request : </label>
                        <textarea
                          v-model="loginForm.details"
                          type="text"
                          class="form-control pl-1"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-md-12">
                                        <div class="form-group ">
                                            <label>Attach Passport, Flight Ticket <span class="text-danger">*</span></label>
                                            <input v-on:change="handleFile()" id="file" ref="file" type="file" class="form-control pl-5" placeholder="Last Name" name="s" required="">
                                          </div>
                                    </div> -->
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label>
                          Attach Passport and other travel documents :
                        </label>
                        <Dropzone
                          ref="myVueDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          :useCustomSlot="true"
                          v-on:vdropzone-success="uploadSuccess"
                          v-on:vdropzone-error="uploadError"
                          v-on:vdropzone-removed-file="fileRemoved"
                          v-on:vdropzone-sending="sendingEvent"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input
                            v-on:click="tnc()"
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck1"
                            required=""
                          />
                          <label class="custom-control-label" for="customCheck1"
                            >I Accept
                            <span class="text-primary"
                              >Terms And Conditions</span
                            ></label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input
                            v-model="loginForm.shuttle"
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck2"
                          />
                          <label class="custom-control-label" for="customCheck2"
                            >Request a Shuttle <br />
                            (Php3,000/Round Trip)</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button class="btn btn-primary btn-block">
                        Book Now
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="mr-lg-5">
              <img
                src="images/user/10811.jpg"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
          <!--end col-->
        </div>
        <button
          id="modalButton"
          href="javascript:void(0)"
          v-b-modal.LoginForm
          data-toggle="modal"
          data-target="#LoginForm"
          style="background: transparent;
                border: none !important;
                font-size:0;"
        >
          Click Here
        </button>
        <!--end row-->
        <!-- The Modal -->
        <div id="myModal" class="modal">
          <div class="modal-content">
            <div class="modal-body">
              <div style="padding: 5px">
                <h4 style="text-align: center">
                  Quarantine Facility Terms and Conditions
                </h4>
              </div>
              <div>
                <ul>
                  <li>
                    <strong>TERMS & CONDITIONS:</strong>
                    <ul>
                      <li>
                        Check-in time starts at 2:00PM and standard check-out
                        time is at 12:00NN.
                      </li>
                      <li>
                        Early check-in is subject to room availability and will
                        have a charge of Php300.00 per hour.
                      </li>
                      <li>
                        Late check-outs or extension, has a corresponding charge
                        amounting to 100% of the rate (inclusive of all
                        prevailing taxes and service charge) will be applied.
                      </li>
                      <li>
                        No visitors are allowed to stay in the assigned room of
                        the guest.
                      </li>
                      <li>
                        Strictly no pets allowed within the hotel premises.
                      </li>
                      <li>
                        Strictly no smoking inside the hotel premises as per the
                        Executive Order no. 26. Smoking penalty of Php2,500.00
                        applies.
                      </li>
                      <li>
                        Any valuables left in the assigned guest room shall not
                        be a liability of QuarantineFacility.ph nor the hotel.
                      </li>
                      <li>
                        The hotel reserves the right to charge a fee should
                        there be stained lines, foul odor, losses and breakages
                        in the room for the duration of the guest’s stay.
                      </li>
                      <li>
                        Cleaning fee will be imposed once the room was
                        vandalized that cost Php500.00
                      </li>
                      <li>
                        QuarantineFacility.ph and the hotel reserve the right to
                        institute necessary actions under any of the following
                        cases:
                        <ul>
                          <li>
                            Failure to pay upon demand of an outstanding amount.
                          </li>
                          <li>Self-check-out.</li>
                        </ul>
                      </li>
                      <li>
                        Cancellation of reservation/cancelled reservation shall
                        result to a 1-day non-refundable payment for all the
                        allotted rooms reserved or booked by the guests.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>PAYMENT TERMS: </strong>
                    <ul>
                      <li>
                        The rates of hotel accommodation with full board meal
                        are inclusive of taxes.
                      </li>
                      <li>
                        The guest shall pay their reservations, fees and sum
                        total of their bookings to QuarantineFacility.ph’s bank
                        account, or any approved bank account or payment option.
                      </li>
                      <li>
                        QuarantineFacility.ph shall issue a billing
                        statement/invoice to the guests via email.
                      </li>
                      <li>
                        The guest shall pay the sum total of the booking fee
                        within three (3) working days.
                      </li>
                      <li>
                        If the guest fails to pay the sum total of the booking
                        fee within three (3) working days after the billing
                        statement has been made, an interest fee of one point
                        five percent (1.5%) shall accrue on a daily basis on the
                        sum total amount of the booking fee.
                      </li>
                      <li>
                        If the guest fails to settle on the said date
                        QuarantineFacility.ph reserves the right to cancel the
                        reservation for rooms.
                      </li>
                      <li>
                        Payment is non-refundable, non-convertible or consumable
                        to any items or services required to reserve the rooms
                        and the space for a particular event.
                      </li>
                      <li>
                        Cancellation of reservation/cancelled reservation shall
                        result to a 1-day non-refundable payment for all the
                        allotted rooms reserved of booked by the guest.
                      </li>
                      <li>
                        The guest must send deposit slip to
                        <span style="color: blue"
                          >finance@quarantinefacility.ph</span
                        >
                        once the payment has been made.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <span v-on:click="closeModal" class="btn btn-primary btn-block"
                >I Agree</span
              >
            </div>
          </div>
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
  </div>
</template>

<style scoped>
#invisibleButton {
  background: transparent;
  border: none !important;
  font-size: 0;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 80%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

/* The Close Button */
.close {
  color: black;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-header {
  padding: 2px 16px;
  background-color: #5cb85c;
  color: white;
}

.modal-body {
  padding: 2px 16px;
}

.modal-footer {
  padding: 2px 16px;
  background-color: #5cb85c;
  color: white;
  text-align: center;
}

* {
  box-sizing: border-box;
}
</style>
